var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#40433F;}\n\t.st1{fill:#40423F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,4.6c0-0.6,0.5-1.1,1.2-1.1v0C9,3.5,9.5,4,9.5,4.6S8.9,5.8,8.3,5.8C7.7,5.8,7.1,5.3,7.1,4.6z M9.7,11.3 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.3-0.1-0.4-0.3c0-0.1,0-0.3,0-0.4c0-0.3,0.1-0.5,0.1-0.8 C8.8,9.4,9,8.6,9.1,7.7c0-0.2,0.1-0.4,0.1-0.7c0-0.3-0.2-0.4-0.4-0.4H6.5c-0.1,0-0.2,0-0.3,0C6.1,6.7,6,6.8,6,6.9 c0,0.1,0.1,0.2,0.2,0.3c0.1,0,0.3,0,0.4,0.1C6.9,7.3,7,7.4,7,7.7c0,0,0,0.1,0,0.1C6.9,8.6,6.7,9.3,6.6,10l-0.2,1.2 c-0.1,0.6,0.5,1.2,1,1.2c0.3,0,0.6,0,0.9,0c0.6,0,1.1-0.3,1.6-0.7c0.1-0.1,0.1-0.2,0.2-0.3C10,11.4,9.9,11.3,9.7,11.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,1c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S4.1,1,8,1 M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0 L8,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3425d8c62312927ff89f2d4f05065f3.svg";
export { ForwardRef as ReactComponent };